import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import marketplaceSettingsActions from '../actions/marketplace-settings'

export const useMarketplaceSettings = () => {
  const data = useSelector((state) => {
    return get(state, 'app.marketplaceSettingsManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(marketplaceSettingsActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
